const pageView = () => ({
  event: 'discoverRendered',
})

export default pageView
